module.exports = __webpack_public_path__ + "static/media/ISSA_CFT31.b02ecfaa.jpg";